import { appClient } from 'api/apiClient';

export type StaffInvitationStatus = 'PENDING' | 'ACCEPTED' | 'REVOKED' | 'EXPIRED';
export type StaffInviteRole = 'CLERK' | 'MERCHANT_ADMIN' | 'PROVIDER_ADMIN';

export interface StaffInvitationPreview {
    email: string;
    role: StaffInviteRole;
    status: StaffInvitationStatus;
    expiresAt: string;
    parishName: string;
}

export interface AcceptStaffInvitationResult {
    parishId: string;
    role: StaffInviteRole;
    staff: {
        id: string;
        role: StaffInviteRole;
        user: { id: string; email: string };
    };
}

/** Public — no JWT required. Used to lock the registration email to the invite. */
export async function previewStaffInvitation(token: string): Promise<StaffInvitationPreview> {
    const params = new URLSearchParams({ token });
    return appClient.get<StaffInvitationPreview>(`invitations/preview?${params.toString()}`);
}

export async function acceptStaffInvitation(token: string): Promise<AcceptStaffInvitationResult> {
    return appClient.post<AcceptStaffInvitationResult>('invitations/accept', { token });
}
